import React, { Component } from 'react';
import connect from 'react-redux/es/connect/connect';
import { createSelector } from 'reselect';
import { Dialog, DialogTitle, DialogContent, Typography, IconButton, DialogActions, Button, TextField, InputLabel } from '@material-ui/core';
//import CloseIcon from '@material-ui/icons/Close';
import SimpleReactValidator from 'simple-react-validator';
import { authService, globalService as gs } from '../../../common/services';
import { alertSelectors, authSelectors } from '../../../common/redux/selectors';
import { Role } from '../../../helpers';

class LoginDialog extends Component {

    constructor(props) {

        super(props);
        this.state = {
            formField: {
                username: '',
                password: '',
            },
            submitted: false,
            loading: false,
        };
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            className: 'valid-feedback d-block text-danger',
            messages: {
                password_repeat: 'Confirm Password is required.'
            }
        });
    }

    handleChange = (e) => {
        let formField = {...this.state.formField};
        formField[e.target.name] = e.target.value;
        this.setState({formField});
    };

    handleSubmit = (e) => {
        e.preventDefault();
        const {formField} = this.state;
        
        if( this.validator.allValid() ) {
            this.setState({loading: true});
            const { dispatch, link } = this.props;
            authService.login(formField).then(authentication => {
                if (authentication.token) {
                    gs.storeItem('authentication', authentication);
                    gs.storeItem('token', authentication.token);
                    dispatch(authSelectors.success(authentication));
                    dispatch(alertSelectors.success(authentication.message));
                    this.setState({loading: false});
                    if(authentication.user.role === Role.User) {
                        window.location.href = link;
                    } else {
                        window.location.href = '/';
                    }
                }
            })
            .catch(exception => {
                console.log('exception', exception);
                const { dispatch, link } = this.props;
                exception && exception.text().then(message => {
                    const errorMessage = JSON.parse(message);
                    (errorMessage !== undefined) && (errorMessage.message !== undefined) && (errorMessage.message.length > 0) && dispatch(alertSelectors.unVerified(errorMessage.message, errorMessage.code));
                    (errorMessage !== undefined) && (errorMessage.errors !== undefined) && (errorMessage.errors.length > 0) && errorMessage.errors.map(item => dispatch(alertSelectors.error(item)));
                });
            });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    };

    handleClose = () => this.props.handleClose();


    render() {
        this.validator.purgeFields();
        const { formField, loading } = this.state;
        const { username, password } = formField;
        const { open } = this.props;
        return (<Dialog onClose={this.handleClose} aria-labelledby="simple-dialog-title" open={open} className="zipcode-dialog">
            <DialogTitle id="simple-dialog-title" className="heading text-center" disableTypography>
                <Typography variant="h6">Login</Typography>
                <IconButton aria-label="close" className="closeButton" onClick={this.handleClose}>
                    {/* <CloseIcon /> */} <i className="fas fa-times"></i>
                </IconButton>
            </DialogTitle>

            <form name="form" onSubmit={this.handleSubmit} noValidate>
                <DialogContent dividers>
                    <div className="form-group">
                        <InputLabel>Email Address</InputLabel>
                        <input type="text" className="form-control" name="username" value={username} onChange={this.handleChange} />
                        {this.validator.message('username', username, 'required|email')}
                    </div>
                    <div className="form-group">
                        <InputLabel>Password</InputLabel>
                        <input type="password" className="form-control" name="password" value={password} onChange={this.handleChange} />
                        {this.validator.message('password', password, 'required')}
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" variant="contained" type="submit" className="btn btn-primary">Submit {loading && <>&nbsp; <div className="spinner-border spinner-border-sm text-white" role="status"></div> </>}</Button>
                    <Button onClick={this.handleClose} type="button" color="primary">
                        Cancel
                    </Button>
                </DialogActions>
            </form>

        </Dialog>);
    }
}

const processSelector = createSelector(
    state => state.process,
    process => process
);

const mapStateToProps = createSelector(
    processSelector,
    (process) => ({
        process
    })
);

export default connect(mapStateToProps)(LoginDialog);